<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
    <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
      <Fields
        v-bind="{fields, object: formData, errors: formErrors}"
        />

      <v-btn type="submit" color="primary">Zapisz</v-btn>
    </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {createPackage, updatePackage} from './api'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import _ from 'lodash'
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    userPackage: {
      type: Object,
      default: function () {
        return {trainer: null, is_active: true}
      }
    }
  },
  data () {
    return {
      isUpdate: false,
      formData: {
        trainer: null,
        is_active: true
      }
    }
  },
  computed: {
    ...mapGetters(['allTrainersOptions']),
    fields () {
      return [
        {comp: 'text', id: 'name', label: 'Nazwa', props: {}},
        {comp: 'textarea', id: 'description', label: 'Opis', props: {}},
        {comp: 'text', id: 'price', label: 'Cena', props: {}},
        {comp: 'select', id: 'trainer', label: 'Domyślny trener', props: {items: this.allTrainersOptions, clearable: true}},
        {comp: 'checkbox', id: 'with_tshirt', label: 'Koszulka', props: {}},
        {comp: 'checkbox', id: 'with_card', label: 'Karta', props: {}},
        {comp: 'checkbox', id: 'is_active', label: 'Aktywny', when: this.isUpdate, props: {}}
      ]
    },
    message () {
      return this.isUpdate ? 'Pakiet został edytowany' : 'Pakiet został dodany'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.userPackage)
    if (this.userPackage.id) {
      this.isUpdate = true
    }
    this.$store.dispatch(types.ALL_TRAINERS_REQUEST)
  },
  methods: {
    prepareData () {
      this.formData.trainer = this.formData.trainer || null
      return this.formData
    },
    submit (data) {
      if (this.isUpdate) {
        return updatePackage(data)
      } else {
        return createPackage(data).then((data) => {
          this.formData = {trainer: null, is_active: true}
          this.validation.reset()
          return data
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/packages/PackageForm.vue